(function() {
  $(document).ready(function () {
    updateProgressBar();
    updateFrequency();
    updatePrice();
    updateTierPrices();
    updateAddToCart();
    // Warm the gift discount cookie while the user browses (LP pattern) so
    // the ATC path doesn't pay the /discount/ round-trip.
    prefetchGiftDiscounts();
  });

  // --- Reset bundle builder (fired when cart drawer closes) ---
  document.addEventListener('bundle:reset', function() {
    updateProgressBar();
    updateFrequency();
    updatePrice();
    updateAddToCart();
  });

  // --- Subscription frequency change ---
  $(document).delegate('#sb-sub-plans-frequency-select', 'change', function () {
    var dataAttrs = $(this).find('option:selected').data();
    $('.bundle-product-list-items .bundle-product-list-item').each(function() {
      $(this).attr('data-selling-plan-id', dataAttrs.sellingPlanId);
    });
    updatePrice();
    updateAddToCart();
  });

  // --- Add flavor ---
  $(document).delegate(".bundle-quantity-container .bundle-add-btn.is-active", "click", function() {
    $(this).removeClass('is-active');
    $(this).next('.bundle-quantity-box').addClass('is-active');
    $(this).parents('.bundle-product-list-item').addClass('item-active');
    var qtyDisplay = $(this).parents('.bundle-quantity-container').find('.bundle-qty-display');
    qtyDisplay.text(1);
    updateProgressBar();
    updateFrequency();
    updatePrice();
    updateAddToCart();
  });

  // --- Quantity plus ---
  $(document).delegate(".bundle-quantity-container .qty-button-plus", "click", function() {
    qtyPlusMinus($(this));
  });

  // --- Quantity minus ---
  $(document).delegate(".bundle-quantity-container .qty-button-minus", "click", function() {
    qtyPlusMinus($(this), -1);
  });

  function qtyPlusMinus(ele, qty) {
    if (typeof qty === 'undefined') qty = 1;
    var qtyDisplay = ele.parents('.bundle-quantity-box').find('.bundle-qty-display');
    var current = parseInt(qtyDisplay.text());

    if (qty === 1) {
      qtyDisplay.text(current + 1);
    } else if (current > 1) {
      qtyDisplay.text(current - 1);
    } else {
      qtyDisplay.text(0);
      ele.parents('.bundle-quantity-box').removeClass('is-active');
      ele.parents('.bundle-product-list-item').removeClass('item-active');
      ele.parents('.bundle-quantity-container').find('.bundle-add-btn').addClass('is-active');
    }

    updateProgressBar();
    updateFrequency();
    updatePrice();
    updateAddToCart();
  }

  // --- Purchase option toggle ---
  $(document).delegate("input[data-sb-sub-selling-plan-group-input]", "change", function () {
    updatePrice();
    updateTierPrices();
    updateAddToCart();
  });

  // --- One-time add-on toggle (sb-addon-offer.liquid) ---
  $(document).delegate(".pdpv3-addon-check", "change", function () {
    updatePrice();
  });

  // --- Tag cart with bundle source so Shopify Flow can apply customer tag ---
  // ============================================================
  // Gift tiers (pdp-v3)
  //
  // Ports the multi-step LP's gift_tier behaviour (sb-lp-funnel-offer-v2 +
  // sb-lp-funnel-v2.js) to the AJAX-cart bundle builder. The LP builds a fresh
  // cart via the Storefront API cartCreate, so it can pass lines + discountCodes
  // in one shot; here the cart already exists, so gifts are added with
  // /cart/add.js and codes are applied by hitting /discount/<codes>, which sets
  // the discount cookie that carries through to checkout.
  //
  // No-ops on any template without [data-gift-variant] tiles, so the shared
  // bundle template and pdp-v2 are unaffected.
  // ============================================================

  function getGiftTiles() {
    return document.querySelectorAll('.pdpv3-gift[data-gift-variant]');
  }

  // Gifts unlocked at the current bag count, as {variantId, code} entries.
  function getUnlockedGifts(totalQty) {
    var out = [];
    Array.prototype.forEach.call(getGiftTiles(), function(tile) {
      var threshold = parseInt(tile.getAttribute('data-unlock-at'), 10) || 1;
      if (totalQty < threshold) return;
      var variantId = String(tile.getAttribute('data-gift-variant') || '').trim();
      if (!variantId) return;
      out.push({
        variantId: variantId,
        code: String(tile.getAttribute('data-gift-discount-code') || '').trim()
      });
    });
    return out;
  }

  // One /discount/ fetch PER code, serial. The comma form (/discount/A,B) does
  // NOT stack — Shopify treats the whole string as one code lookup and applies
  // nothing (verified in sb-lp-funnel.js, which moved to ?discount= on the
  // checkout URL for the same reason). Usually one code, so the loop is cheap.
  function applyGiftDiscounts(codes, callback) {
    var i = 0;
    var next = function() {
      if (i >= codes.length) { if (callback) callback(); return; }
      var code = codes[i++];
      fetch('/discount/' + encodeURIComponent(code) + '?redirect=/cart.js', { credentials: 'same-origin' })
        .catch(function(err) { console.error('Gift discount error:', err); })
        .then(next);
    };
    next();
  }

  // Add unlocked gifts, skipping any already in the cart so a second Add to
  // Cart can't stack a second free unit, then apply their codes. Best-effort:
  // a sold-out gift must never block the real add, so failures fall through.
  // Subscription-only. The blocks are "Gift (subscription)" and their badges
  // stage across renewals ("First order", "Month 2"), so a one-time order must
  // never pull a free gift in — the FREEGIFT code would zero it with no
  // subscription behind it.
  function isSubscriptionSelected() {
    return $('.bundle-product-purchase-options .sb-sub-otp.sb-sub-group-inactive').length === 1;
  }

  // Speed architecture (the LP's tricks, adapted to an AJAX cart):
  //   1. The discount code is PREFETCHED at page load — same as the LP's
  //      /discount/CODE prefetch. Verified: a code attached to an empty cart
  //      sticks and turns applicable the moment the gift line lands.
  //   2. Gift lines ride in the SAME /cart/add.js as the teas — no second add.
  //   3. Dedupe is an absolute-quantity clamp (updates: {variant: 1}) merged
  //      into the /cart/update.js call that sets the source attribute anyway —
  //      idempotent, so a second ATC can't stack a second free unit, and it
  //      costs zero extra requests.
  //   4. ensureGiftDiscounts re-applies the code when update.js's returned
  //      discount_codes does not hold it. The update.js call now clears every
  //      code (see setBundleSourceAttribute), so this step always runs and
  //      always pays one /discount/ round-trip. That is the price of dropping
  //      a stale lander code, and it costs the same as reading the cart first.
  // Net: subscribe ATC is add -> update -> drawer, the same depth as one-time.
  function prefetchGiftDiscounts() {
    var codes = [];
    Array.prototype.forEach.call(getGiftTiles(), function(tile) {
      var c = String(tile.getAttribute('data-gift-discount-code') || '').trim();
      if (c && codes.indexOf(c) === -1) codes.push(c);
    });
    if (codes.length) applyGiftDiscounts(codes, null);
  }

  // Codes the unlocked gifts need that update.js's cart says aren't attached.
  function ensureGiftDiscounts(cart, gifts, callback) {
    var done = function() { if (callback) callback(); };
    var attached = {};
    ((cart && cart.discount_codes) || []).forEach(function(d) { attached[d.code] = true; });
    var missing = [];
    gifts.forEach(function(g) {
      if (g.code && !attached[g.code] && missing.indexOf(g.code) === -1) missing.push(g.code);
    });
    if (!missing.length) { done(); return; }
    applyGiftDiscounts(missing, done);
  }

  // One-time add-on cards (snippets/sb-addon-offer.liquid). Each checked card
  // adds its variant once, with no selling plan. The `_addon` line property
  // marks the line, so Sinensis can count add-on purchases. The value names
  // the surface: 'add-on-page' on the PDP, 'add-on-cart' in the cart drawer
  // (assets/sb-cart-drawer.js).
  function getSelectedAddons() {
    var out = [];
    $('.pdpv3-addon-check:checked').each(function() {
      out.push({ id: $(this).attr('data-variant-id'), quantity: 1, properties: { _addon: 'add-on-page' } });
    });
    return out;
  }
  function payloadHasAddon(payload) {
    return payload.some(function(it) { return it.properties && it.properties._addon; });
  }
  function stripAddons(payload) {
    return payload.filter(function(it) { return !(it.properties && it.properties._addon); });
  }
  // sb-addon-offer.liquid listens and sends the addon_atc pixel event.
  function announceAddonAtc(payload) {
    if (!payloadHasAddon(payload)) return;
    try { document.dispatchEvent(new CustomEvent('sb:addon:atc')); } catch (e) {}
  }

  // /cart/update.js responds with the FULL cart JSON — passed to the callback
  // so downstream steps (gift discounts, frequency reconcile) can reuse it
  // instead of re-fetching /cart.js. giftClamps ({variantId: 1}) rides along.
  //
  // `discount: ''` clears EVERY code on the cart. Shopify keeps codes on the
  // cart, not on the page, and codes STACK — a new code never replaces an old
  // one. So a tier code from an earlier lander visit
  // (FIRSTORDER_PROMO_MT_0X_US) survives an empty cart and discounts the tea
  // added here. The clear runs BEFORE ensureGiftDiscounts, which then puts back
  // only the gift codes this page owns.
  function setBundleSourceAttribute(giftClamps, callback) {
    if (typeof giftClamps === 'function') { callback = giftClamps; giftClamps = null; }
    // `source` drives the Loop rewards journey. `template` is what a Shopify
    // Flow rule reads to tag the order with the template it came from. The
    // suffix comes from Liquid because this file also runs on pdp-v2.
    // Empty strings remove the multi-step funnel keys. A visitor who leaves a
    // multi-step page and buys here must not keep its lander and tier tags.
    var attrs = {
      source: 'organic-offer-bundle',
      'multi-step-lp': '',
      tier: '',
      purchase_type: ''
    };
    if (window.SB_TEMPLATE) attrs.template = window.SB_TEMPLATE;
    var body = { attributes: attrs, discount: '' };
    if (giftClamps && Object.keys(giftClamps).length) body.updates = giftClamps;
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function(r) { return r.json(); })
      .then(function(cart) { if (callback) callback(cart); })
      .catch(function(err) {
        console.error('Bundle source attribute error:', err);
        if (callback) callback(null);
      });
  }

  // --- Subscribe button ---
  $(document).delegate("#bundle_buy_button", "click", function(e) {
    e.preventDefault();
    if (!$(this).prop('disabled')) {
      var btn = $(this);
      btn.attr('disabled', 'disabled').addClass('disabled');
      btn.find('.loading__spinner').removeClass('hidden');
      var has_subscription = $('.bundle-product-purchase-options .sb-sub-otp.sb-sub-group-inactive').length;
      var items = [];
      $('.bundle-product-list-items .bundle-product-list-item.item-active:not([data-sold-out])').each(function() {
        var item = {
          id: $(this).attr('data-variant-id'),
          quantity: parseInt($(this).find('.bundle-qty-display').text())
        };
        var isPreOrder = $(this).attr('data-pre-order') === 'true';
        if (has_subscription === 1) {
          item.selling_plan = $(this).attr('data-selling-plan-id');
        }
        if (isPreOrder) {
          var preOrderMsg = $(this).attr('data-pre-order-message') || 'Pre-order';
          item.properties = { 'Pre-order': preOrderMsg };
        }
        items.push(item);
      });

      // Checked one-time add-ons ride in the same add.js request.
      getSelectedAddons().forEach(function(a) { items.push(a); });

      // Unlocked gifts ride in the SAME add.js request as the teas —
      // subscription only (the blocks stage by renewal; see ensureGiftDiscounts).
      var gifts = [];
      if (has_subscription === 1 && isSubscriptionSelected()) {
        gifts = getUnlockedGifts(getTotalQuantity());
        gifts.forEach(function(g) {
          items.push({ id: g.variantId, quantity: 1, properties: { _gift: 'true' } });
        });
      }

      // A sold-out gift 422s the WHOLE combined add (the LP has the same
      // failure mode on cartCreate) — retry once with the teas only.
      var attempt = function(payload, giftsIncluded) {
        $.ajax({
          type: 'POST',
          url: '/cart/add.js',
          data: JSON.stringify({ items: payload }),
          dataType: 'json',
          contentType: 'application/json',
          success: function() {
            announceAddonAtc(payload);
            // Clamp each gift to absolute qty 1 (dedupe for repeat ATC) in the
            // same update.js that sets the source attribute. Discount is
            // normally already attached by the page-load prefetch; the
            // reconcile and the rare re-apply run CONCURRENTLY off the
            // returned cart, then the drawer opens.
            var clamps = {};
            if (giftsIncluded) {
              gifts.forEach(function(g) { clamps[g.variantId] = 1; });
            }
            setBundleSourceAttribute(clamps, function(cart) {
              var pending = 2;
              var openDrawer = function() {
                pending--;
                if (pending > 0) return;
                btn.removeAttr('disabled').removeClass('disabled');
                btn.find('.loading__spinner').addClass('hidden');
                var drawer = document.querySelector('cart-drawer');
                if (drawer && drawer.fetchAndOpen) drawer.fetchAndOpen();
              };
              if (giftsIncluded) {
                ensureGiftDiscounts(cart, gifts, openDrawer);
              } else {
                openDrawer();
              }
              if (has_subscription === 1) {
                reconcileCartFrequency(cart, openDrawer);
              } else {
                openDrawer();
              }
            });
          },
          error: function(err) {
            if (giftsIncluded && gifts.length) {
              console.error('Combined add failed, retrying without gifts:', err.responseText || err);
              var flavorsOnly = payload.filter(function(it) {
                return !(it.properties && it.properties._gift);
              });
              attempt(flavorsOnly, false);
              return;
            }
            // A sold-out add-on 422s the whole request too — one more
            // retry with the teas only.
            if (payloadHasAddon(payload)) {
              console.error('Add failed, retrying without add-ons:', err.responseText || err);
              attempt(stripAddons(payload), false);
              return;
            }
            btn.removeAttr('disabled').removeClass('disabled');
            btn.find('.loading__spinner').addClass('hidden');
            console.error('Bundle cart error:', err.responseText || err);
          }
        });
      };
      attempt(items, gifts.length > 0);
    }
  });

  // --- Buy once button ---
  $(document).delegate("#bundle_buy_once_button", "click", function(e) {
    e.preventDefault();
    if (!$(this).prop('disabled')) {
      var btn = $(this);
      btn.attr('disabled', 'disabled').addClass('disabled');
      btn.find('.loading__spinner').removeClass('hidden');
      var items = [];
      $('.bundle-product-list-items .bundle-product-list-item.item-active:not([data-sold-out])').each(function() {
        var item = {
          id: $(this).data('variant-id'),
          quantity: parseInt($(this).find('.bundle-qty-display').text())
        };
        if ($(this).attr('data-pre-order') === 'true') {
          var preOrderMsg = $(this).attr('data-pre-order-message') || 'Pre-order';
          item.properties = { 'Pre-order': preOrderMsg };
        }
        items.push(item);
      });

      // Checked one-time add-ons ride in the same add.js request.
      getSelectedAddons().forEach(function(a) { items.push(a); });

      var attemptOnce = function(payload) {
        $.ajax({
          type: 'POST',
          url: '/cart/add.js',
          data: JSON.stringify({ items: payload }),
          dataType: 'json',
          contentType: 'application/json',
          success: function() {
            announceAddonAtc(payload);
            // No gift sync here — this is the explicit one-time path.
            setBundleSourceAttribute(function() {
              btn.removeAttr('disabled').removeClass('disabled');
              btn.find('.loading__spinner').addClass('hidden');
              var drawer = document.querySelector('cart-drawer');
              if (drawer && drawer.fetchAndOpen) drawer.fetchAndOpen();
            });
          },
          error: function(err) {
            // A sold-out add-on 422s the whole request — retry with the
            // teas only.
            if (payloadHasAddon(payload)) {
              console.error('Add failed, retrying without add-ons:', err && err.responseText || err);
              attemptOnce(stripAddons(payload));
              return;
            }
            btn.removeAttr('disabled').removeClass('disabled');
            btn.find('.loading__spinner').addClass('hidden');
          }
        });
      };
      attemptOnce(items);
    }
  });

  // --- Notify Me popup (Klaviyo back-in-stock) ---
  $(document).delegate(".bundle-add-btn.is-notify", "click", function(e) {
    e.preventDefault();
    var $card = $(this).closest('.bundle-product-list-item');
    var productName = $card.find('.bundle-product-name').text().trim();
    var variantId = $(this).data('variant-id');
    var productHandle = $card.data('product-handle');
    $('#sb-notify-product-name').text(productName);
    $('#sb-notify-form').data('variant-id', variantId).data('product-handle', productHandle);
    $('#sb-notify-feedback').attr('hidden', true);
    $('#sb-notify-popup').removeAttr('hidden');
    $('#sb-notify-email').val('').focus();
  });

  // Close popup
  $(document).delegate(".sb-notify-popup__close, .sb-notify-popup__backdrop", "click", function() {
    $('#sb-notify-popup').attr('hidden', true);
  });
  $(document).on('keydown', function(e) {
    if (e.key === 'Escape' && !$('#sb-notify-popup').is('[hidden]')) {
      $('#sb-notify-popup').attr('hidden', true);
    }
  });

  // Submit to Klaviyo
  $(document).delegate("#sb-notify-form", "submit", function(e) {
    e.preventDefault();
    var email = $('#sb-notify-email').val();
    var variantId = $(this).data('variant-id');
    var $feedback = $('#sb-notify-feedback');
    var $btn = $(this).find('button[type="submit"]');
    $btn.prop('disabled', true).text('Sending...');

    var productName = $('#sb-notify-product-name').text();
    var productHandle = $('#sb-notify-form').data('product-handle');

    // Step 1: Subscribe email to list
    var subscribePromise = fetch('https://a.klaviyo.com/client/subscriptions/?company_id=SkxvMg', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'revision': '2024-10-15'
      },
      body: JSON.stringify({
        data: {
          type: 'subscription',
          attributes: {
            custom_source: 'Bundle Builder - Back in Stock',
            profile: {
              data: {
                type: 'profile',
                attributes: { email: email }
              }
            }
          },
          relationships: {
            list: {
              data: {
                type: 'list',
                id: 'SxwLpF'
              }
            }
          }
        }
      })
    });

    // Step 2: Log event with product details (segmentable per flavor)
    var eventPromise = fetch('https://a.klaviyo.com/client/events/?company_id=SkxvMg', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'revision': '2024-10-15'
      },
      body: JSON.stringify({
        data: {
          type: 'event',
          attributes: {
            metric: { data: { type: 'metric', attributes: { name: 'Back in Stock Request' } } },
            profile: { data: { type: 'profile', attributes: { email: email } } },
            properties: {
              'Product Name': productName,
              'Product Handle': productHandle,
              'Variant ID': variantId
            }
          }
        }
      })
    });

    Promise.all([subscribePromise, eventPromise])
    .then(function(responses) {
      var failed = responses.some(function(res) { return !res.ok; });
      if (failed) throw new Error('Request failed');
      $feedback.text("You're on the list! We'll notify you.").removeAttr('hidden').removeClass('is-error');
      $btn.prop('disabled', false).text('Notify Me');
      setTimeout(function() { $('#sb-notify-popup').attr('hidden', true); }, 2000);
    })
    .catch(function() {
      $feedback.text('Something went wrong. Try again.').removeAttr('hidden').addClass('is-error');
      $btn.prop('disabled', false).text('Notify Me');
    });
  });

  // ============================================================
  // Progress Bar
  // ============================================================

  function getTotalQuantity() {
    var total = 0;
    $('.bundle-product-list-items .bundle-product-list-item.item-active').each(function() {
      total += parseInt($(this).find('.bundle-qty-display').text()) || 0;
    });
    return total;
  }

  function getCurrentTier() {
    var totalQty = getTotalQuantity();
    var currentTier = null;
    $('.sb-tier-progress__step').each(function() {
      var bagCount = $(this).data('bag-count');
      if (totalQty >= bagCount) {
        currentTier = $(this);
      }
    });
    return currentTier;
  }

  function updateProgressBar() {
    var totalQty = getTotalQuantity();
    var steps = $('.sb-tier-progress__step');
    var totalSteps = steps.length;
    if (totalSteps === 0) return;

    // Reset all steps
    steps.removeClass('is-reached is-active');

    // Determine fill width and active states
    var fillPercent = 0;
    var activeIndex = -1;

    steps.each(function(index) {
      var bagCount = $(this).data('bag-count');
      if (totalQty >= bagCount) {
        $(this).addClass('is-reached');
        activeIndex = index;
      }
    });

    // Set active on the current tier
    if (activeIndex >= 0) {
      steps.eq(activeIndex).addClass('is-active');
    }

    // Calculate fill percentage (0% at first node, 100% at last node)
    if (activeIndex < 0) {
      fillPercent = 0;
    } else {
      fillPercent = (activeIndex / (totalSteps - 1)) * 100;
    }

    // Fill is handled by CSS — .is-reached class on steps turns their ::before brown
  }

  // ============================================================
  // Price Calculation
  // ============================================================

  function formatPrice(price) {
    if (typeof price === 'undefined') price = 0;
    var symbol = window.currencySymbol || '$';
    var code = window.currencyCode || 'USD';
    return (price / 100).toLocaleString('en-US', {
      style: 'currency',
      currency: code
    });
  }

  // Checked add-on cards (sb-addon-offer.liquid), in cents. Feeds the button
  // price only — the cart add reads the same checkboxes in getAddonItems().
  // The savings pill stays tea-only: the add-on carries no discount, so
  // including it would shrink the advertised percentage.
  function getAddonPriceTotals() {
    var totals = { price: 0, compare: 0 };
    $('.pdpv3-addon-check:checked').each(function () {
      var p = parseInt($(this).attr('data-price'), 10) || 0;
      var c = parseInt($(this).attr('data-compare-at-price'), 10) || 0;
      totals.price += p;
      totals.compare += (c > p ? c : p);
    });
    return totals;
  }

  function getActiveTierData() {
    var totalQty = getTotalQuantity();
    var tierData = {
      bagCount: 1,
      discount: 0,
      subscriptionDiscount: 0
    };

    // Default to first step values
    var firstStep = $('.sb-tier-progress__step').first();
    if (firstStep.length) {
      tierData.bagCount = firstStep.data('bag-count');
      tierData.discount = firstStep.data('discount');
      tierData.subscriptionDiscount = firstStep.data('subscription-discount');
    }

    // Find best tier based on total quantity
    $('.sb-tier-progress__step').each(function() {
      var bagCount = $(this).data('bag-count');
      if (totalQty >= bagCount) {
        tierData.bagCount = bagCount;
        tierData.discount = $(this).data('discount');
        tierData.subscriptionDiscount = $(this).data('subscription-discount');
      }
    });

    return tierData;
  }

  // Price after a percentage discount, in cents. Shopify cuts each discount
  // down to the cent, so the page does the same and shows what checkout charges.
  function discountedCents(cents, pct) {
    cents = Number(cents) || 0;
    return cents - Math.floor(cents * (Number(pct) || 0) / 100 + 1e-6);
  }

  // The base bag: the flavor with the lowest price. The "/ea" price uses it,
  // so one premium bag (Matcha) in the box does not change the per-bag price.
  function getBaseItem() {
    var base = null;
    $('.bundle-product-list-items .bundle-product-list-item').each(function () {
      var p = Number($(this).data('price')) || 0;
      if (p && (!base || p < (Number(base.data('price')) || 0))) base = $(this);
    });
    return base || $('.bundle-product-list-items .bundle-product-list-item:first');
  }

  // "+$13.20" on each flavor that costs more than the base bag, at the tier
  // the box is on now. Subscription compares plan prices; one-time compares
  // product prices.
  function updatePremiumPills(tier, isSubscription) {
    var base = getBaseItem();
    var baseSub = discountedCents(base.data('recurring-price'), tier.subscriptionDiscount);
    var baseOnce = discountedCents(base.data('price'), tier.discount);
    $('.bundle-product-list-items .bundle-product-list-item').each(function () {
      var pill = $(this).find('[data-flavor-premium]');
      if (!pill.length) return;
      var extra = isSubscription
        ? discountedCents($(this).data('recurring-price'), tier.subscriptionDiscount) - baseSub
        : discountedCents($(this).data('price'), tier.discount) - baseOnce;
      if (extra > 0) {
        pill.text('+' + formatPrice(extra)).prop('hidden', false);
      } else {
        pill.text('').prop('hidden', true);
      }
    });
  }

  function updatePrice() {
    var tier = getActiveTierData();
    var buyOnceButton = $('#bundle_buy_once_button');
    var savingsPill = $('#sb_savings_pill');
    var btnPrices = $('#sb_btn_prices');
    var btnStrike = $('#sb_btn_strike');
    var btnSale = $('#sb_btn_sale');
    var has_subscription = $('.bundle-product-purchase-options .sb-sub-otp.sb-sub-group-inactive').length;
    var activeItems = $('.bundle-product-list-items .bundle-product-list-item.item-active');
    updatePremiumPills(tier, has_subscription === 1);

    if (activeItems.length === 0) {
      // No items selected — show default pricing from the base bag
      var product = getBaseItem();
      var price = product.data('price');
      var compareAtPrice = product.data('compare-at-price');
      var recurringPrice = product.data('recurring-price');
      var discountedPrice = discountedCents(price, tier.discount);
      var discountedRecurringPrice = discountedCents(recurringPrice, tier.subscriptionDiscount);

      $('.product .product__info-wrapper [data-sb-sub-form-id] [data-sb-sub-selling-plan-group-id]').each(function () {
        $(this).find('[data-sb-sub-compare-price]').text(formatPrice(compareAtPrice)).removeClass('hidden');
        $(this).find('[data-sb-sub-subscribe-price]').text(formatPrice(discountedRecurringPrice) + '/ea').removeClass('hidden');
        $(this).find('[data-sb-sub-regular-price]').text(formatPrice(price)).removeClass('hidden');
        if ($(this).hasClass('sb-sub-otp')) {
          $(this).find('[data-sb-sub-subscribe-price]').text(formatPrice(discountedPrice) + '/ea');
          $(this).find('[data-sb-sub-regular-price]').text(formatPrice(price));
        }
      });

      // Show default savings pill (1-bag tier)
      var defaultSavingsPercent = Math.round((price - discountedRecurringPrice) / price * 100);
      if (defaultSavingsPercent > 0) {
        savingsPill.text('SAVE ' + defaultSavingsPercent + '% ON FIRST ORDER').show();
        $('[data-benefits-pct]').text(defaultSavingsPercent);
      } else {
        savingsPill.hide();
      }
      btnPrices.addClass('hidden');
      buyOnceButton.addClass('hidden');
      buyOnceButton.find('.money').text(formatPrice(0));
      $('.free-gift-note').addClass('hidden');

    } else {
      // Items selected — calculate based on auto-detected tier. The "/ea"
      // price is the base bag's, whatever bag the shopper added first.
      var product = getBaseItem();
      var price = product.data('price');
      var compareAtPrice = product.data('compare-at-price');
      var recurringPrice = product.data('recurring-price');
      var discountedPrice = discountedCents(price, tier.discount);
      var discountedRecurringPrice = discountedCents(recurringPrice, tier.subscriptionDiscount);

      $('.product .product__info-wrapper [data-sb-sub-form-id] [data-sb-sub-selling-plan-group-id]').each(function () {
        $(this).find('[data-sb-sub-compare-price]').text(formatPrice(compareAtPrice)).removeClass('hidden');
        $(this).find('[data-sb-sub-subscribe-price]').text(formatPrice(discountedRecurringPrice) + '/ea').removeClass('hidden');
        $(this).find('[data-sb-sub-regular-price]').text(formatPrice(price)).removeClass('hidden');
        if ($(this).hasClass('sb-sub-otp')) {
          $(this).find('[data-sb-sub-subscribe-price]').text(formatPrice(discountedPrice) + '/ea');
          $(this).find('[data-sb-sub-regular-price]').text(formatPrice(price));
        }
      });

      // Calculate totals
      var totalPrice = 0;
      var totalDiscountedPrice = 0;
      var totalDiscountedRecurringPrice = 0;

      activeItems.each(function() {
        var p = $(this).data('price');
        var rp = $(this).data('recurring-price');
        var dp = discountedCents(p, tier.discount);
        var drp = discountedCents(rp, tier.subscriptionDiscount);
        var qty = parseInt($(this).find('.bundle-qty-display').text());
        totalPrice += p * qty;
        totalDiscountedPrice += dp * qty;
        totalDiscountedRecurringPrice += drp * qty;
      });

      // Savings pill + button prices
      var addonTotals = getAddonPriceTotals();
      if (has_subscription === 1) {
        var savingsPercent = Math.round((totalPrice - totalDiscountedRecurringPrice) / totalPrice * 100);
        if (savingsPercent > 0) {
          savingsPill.text('SAVE ' + savingsPercent + '% ON FIRST ORDER').show();
          $('[data-benefits-pct]').text(savingsPercent);
        } else {
          savingsPill.hide();
        }
        btnStrike.text(formatPrice(totalPrice + addonTotals.compare));
        btnSale.text(formatPrice(totalDiscountedRecurringPrice + addonTotals.price));
        btnPrices.removeClass('hidden');
      } else {
        savingsPill.hide();
        if (totalDiscountedPrice < totalPrice) {
          btnStrike.text(formatPrice(totalPrice + addonTotals.compare));
          btnSale.text(formatPrice(totalDiscountedPrice + addonTotals.price));
          btnPrices.removeClass('hidden');
        } else {
          btnPrices.addClass('hidden');
        }
      }

      buyOnceButton.removeClass('hidden');
      buyOnceButton.find('.money').text(formatPrice(totalDiscountedPrice + addonTotals.price));
      $('.free-gift-note').removeClass('hidden');

    }
  }

  // ============================================================
  // Tier Progress Bar Per-Bag Prices
  // ============================================================

  function updateTierPrices() {
    // The base bag, not the first row: sold-out flavors sort to the bottom, so the first row can change.
    var product = getBaseItem();
    if (!product.length) return;
    var price = product.data('price');
    var recurringPrice = product.data('recurring-price');
    var has_subscription = $('.bundle-product-purchase-options .sb-sub-otp.sb-sub-group-inactive').length;

    $('.sb-tier-progress__step').each(function() {
      var subDiscount = $(this).data('subscription-discount');
      var onetimeDiscount = $(this).data('discount');
      var perBag;
      if (has_subscription === 1) {
        perBag = recurringPrice - (recurringPrice * subDiscount / 100);
      } else {
        perBag = price - (price * onetimeDiscount / 100);
      }
      // Price per cup label is set in the theme editor (static display)
    });
  }

  // ============================================================
  // Add to Cart Validation
  // ============================================================

  function updateAddToCart() {
    var totalQty = getTotalQuantity();
    var bundle_buy_button = $('#bundle_buy_button');
    var bundle_buy_once_button = $('#bundle_buy_once_button');
    var incentive = $('#bundle_incentive');

    if (totalQty === 0) {
      // No items — disabled
      bundle_buy_button.find('span').first().text('Select at least 1 bag');
      bundle_buy_button.attr('disabled', 'disabled');
      bundle_buy_once_button.attr('disabled', 'disabled');
      incentive.addClass('hidden').text('');
    } else {
      // 1+ items — enabled
      bundle_buy_button.find('span').first().text('Add to Cart');
      bundle_buy_button.removeAttr('disabled');
      bundle_buy_once_button.removeAttr('disabled');

      // Show incentive for next tier
      var nextTier = null;
      $('.sb-tier-progress__step').each(function() {
        var bagCount = $(this).data('bag-count');
        if (totalQty < bagCount && nextTier === null) {
          nextTier = {
            bagCount: bagCount,
            discount: $(this).data('discount')
          };
        }
      });

      if (nextTier) {
        var bagsNeeded = nextTier.bagCount - totalQty;
        var word = bagsNeeded === 1 ? 'bag' : 'bags';
        incentive.text('Add ' + bagsNeeded + ' more ' + word + ' to save ' + nextTier.discount + '%!');
        incentive.removeClass('hidden');
      } else {
        incentive.addClass('hidden').text('');
      }
    }
  }

  // ============================================================
  // Auto-set Subscription Frequency based on quantity
  // 1-2 bags → 30 days, 3-4 bags → 60 days, 5+ bags → 90 days
  // Selling plan: "Bundle Builder" (Loop Subscriptions)
  // ============================================================

  var FREQUENCY_PLAN_MAP = {
    '30': 4573528164,
    '60': 4573593700,
    '90': 4582408292
  };

  function getSellingPlanId(targetDays) {
    // Try select options first, fall back to hardcoded map
    var planId = null;
    var $select = $('#sb-sub-plans-frequency-select');
    $select.find('option').each(function() {
      var freqText = ($(this).attr('data-selling-frequency-id') || $(this).text()).toString();
      if (freqText.indexOf(targetDays) !== -1) {
        planId = parseInt($(this).attr('data-selling-plan-id'));
        return false;
      }
    });
    if (!planId && FREQUENCY_PLAN_MAP[targetDays]) {
      planId = FREQUENCY_PLAN_MAP[targetDays];
    }
    return planId;
  }

  // ============================================================
  // Cart Frequency Reconciliation
  // After adding subscription items, check if the total bundle
  // quantity in cart crosses a tier threshold and update all
  // bundle line items to the correct selling plan frequency.
  // ============================================================

  function reconcileCartFrequency(cartSnapshot, callback) {
    // Back-compat: old call sites pass only a callback.
    if (typeof cartSnapshot === 'function') { callback = cartSnapshot; cartSnapshot = null; }
    // Collect bundle variant IDs from the page
    var bundleVariantIds = [];
    $('.bundle-product-list-items .bundle-product-list-item').each(function() {
      bundleVariantIds.push(parseInt($(this).attr('data-variant-id')));
    });

    // The teas are already in the snapshot (added before /cart/update.js
    // returned it), and the gift line added in parallel is never a
    // subscription line, so the snapshot is sufficient — no GET /cart.js.
    var run = function(cart) {
      // Count total bundle subscription items in cart
      var totalBundleQty = 0;
      var bundleLineKeys = [];
      for (var i = 0; i < cart.items.length; i++) {
        var item = cart.items[i];
        if (bundleVariantIds.indexOf(item.variant_id) !== -1 && item.selling_plan_allocation) {
          totalBundleQty += item.quantity;
          bundleLineKeys.push({ key: item.key, currentPlanId: item.selling_plan_allocation.selling_plan.id });
        }
      }

      // Determine correct frequency for this total
      var targetDays;
      if (totalBundleQty <= 2) targetDays = '30';
      else if (totalBundleQty <= 4) targetDays = '60';
      else targetDays = '90';

      // Find the correct selling plan ID
      var correctPlanId = getSellingPlanId(targetDays);

      if (!correctPlanId || bundleLineKeys.length === 0) {
        callback();
        return;
      }

      // Check if any line items need updating
      var linesToUpdate = [];
      for (var j = 0; j < bundleLineKeys.length; j++) {
        if (bundleLineKeys[j].currentPlanId !== correctPlanId) {
          linesToUpdate.push(bundleLineKeys[j]);
        }
      }

      if (linesToUpdate.length === 0) {
        callback();
        return;
      }

      // Update each line item's selling plan sequentially
      var updateIndex = 0;
      function updateNext() {
        if (updateIndex >= linesToUpdate.length) {
          callback();
          return;
        }
        var line = linesToUpdate[updateIndex];
        $.ajax({
          type: 'POST',
          url: '/cart/change.js',
          data: JSON.stringify({ id: line.key, selling_plan: correctPlanId }),
          dataType: 'json',
          contentType: 'application/json',
          complete: function() {
            updateIndex++;
            updateNext();
          }
        });
      }
      updateNext();
    };

    if (cartSnapshot && cartSnapshot.items) { run(cartSnapshot); return; }
    $.getJSON('/cart.js', run).fail(function() {
      callback();
    });
  }

  function updateFrequency() {
    var $select = $('#sb-sub-plans-frequency-select');
    if (!$select.length) return;

    var totalQty = getTotalQuantity();
    var targetDays;
    if (totalQty <= 2) {
      targetDays = '30';
    } else if (totalQty <= 4) {
      targetDays = '60';
    } else {
      targetDays = '90';
    }

    // Find the option whose frequency text contains the target days
    var $targetOption = null;
    $select.find('option').each(function() {
      var freqText = ($(this).attr('data-selling-frequency-id') || $(this).text()).toString();
      if (freqText.indexOf(targetDays) !== -1) {
        $targetOption = $(this);
        return false;
      }
    });

    // Get the correct plan ID (from select or fallback map)
    var newPlanId = getSellingPlanId(targetDays);

    if ($targetOption) {
      $select.val($targetOption.val());
    }

    if (newPlanId) {
      $('.bundle-product-list-items .bundle-product-list-item').each(function() {
        $(this).attr('data-selling-plan-id', newPlanId);
      });
    }

    // Update the visible frequency label
    var $label = $('[data-sb-sub-selling-plan-pills-header]');
    if ($label.length) {
      var freqText;
      if ($targetOption) {
        freqText = ($targetOption.attr('data-selling-frequency-id') || $targetOption.text()).toString();
      } else {
        freqText = 'Deliver every ' + targetDays + ' days';
      }
      freqText = freqText.replace(/Deliver(ed)?\s+every\s+/i, '');
      $label.text('Every ' + freqText);
    }
  }

  // ============================================================
  // Delivery Date Estimate
  // ============================================================

  function updateDeliveryDate() {
    var $dateEl = $('.sb-delivery-info__date');
    if (!$dateEl.length) return;

    var now = new Date();
    var hour = now.getHours();
    var day = now.getDay(); // 0=Sun, 6=Sat

    // If it's after 2pm or weekend, shipping starts next business day
    var shipsDate = new Date(now);
    if (hour >= 14 || day === 0 || day === 6) {
      shipsDate.setDate(shipsDate.getDate() + 1);
    }
    // Advance to next Monday if landing on weekend
    while (shipsDate.getDay() === 0 || shipsDate.getDay() === 6) {
      shipsDate.setDate(shipsDate.getDate() + 1);
    }

    // Calculate delivery window: 2-5 business days from ship date
    function addBusinessDays(start, days) {
      var d = new Date(start);
      var added = 0;
      while (added < days) {
        d.setDate(d.getDate() + 1);
        if (d.getDay() !== 0 && d.getDay() !== 6) {
          added++;
        }
      }
      return d;
    }

    var earliest = addBusinessDays(shipsDate, 2);
    var latest = addBusinessDays(shipsDate, 5);

    var opts = { month: 'short', day: 'numeric' };
    var earliestStr = earliest.toLocaleDateString('en-US', opts);
    var latestStr = latest.toLocaleDateString('en-US', opts);

    $dateEl.text('Delivered by ' + earliestStr + ' – ' + latestStr);
  }

  $(document).ready(function () {
    updateDeliveryDate();
  });

  // ============================================================
  // Sticky Footer
  // ============================================================

  $(document).ready(function () {
    const $sticky = $('.bundle_footer_wrapper');
    const $startEl = $('.bundle_content_wrapper');
    const $endEl = $('.bundle_content_wrapper');

    if (!$startEl.length || !$endEl.length || !$sticky.length) return;

    $(window).on('scroll', function () {
      const windowTop = $(window).scrollTop();
      const windowBottom = windowTop + $(window).height();
      const startOffset = $startEl.offset().top + 150;
      const endBottom = $endEl.offset().top + $endEl.outerHeight();

      if (windowBottom > startOffset && windowBottom < endBottom) {
        $sticky.addClass('is-sticky-active');
      } else {
        $sticky.removeClass('is-sticky-active');
      }
    }).trigger('scroll');
  });
})();
